import useMediaQuery from 'housecall-ui/dist/DesignSystem/Styles/useMediaQuery';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

export default function useSmallScreen() {
  return useMediaQuery((theme: HCPTheme) => theme.breakpoints.down('sm'));
}
